<template>
    <div>
      <div class="detailed-info">
        <div class="detailed-info__block-1">
          <div class="detailed-info-device">
            <v-col cols="12" sm="12" class="pb-0">
              <div class="snapshot-device" v-if="doorphone.physical_status !== 5 && doorphone.physical_status !== 6">
                <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
                <v-img
                  :src="snapshot"
                  max-width="550"
                  max-height="400"
                  class="image-device mt-2"
                  @click.stop="getDialogImage"
                  alt="Изображение отсутствует"
                ></v-img>
                <v-dialog
                  v-if="disableRole"
                  v-model="dialogImage"
                  :max-width="isMobile ? '70%' : '45%'"
                  content-class="over-dialog"
                  style="height: 528px;"
                >
                  <div
                    :style="isMobile ? 'height: 100%;' : 'height: 528px;'"
                    style="position: relative; width: 100%;"
                  >
                    <Player
                      v-if="dialogImagePlayer"
                      ref="Player"
                      :key="channel.id"
                      :channel="channel"
                    />
                  </div>
                </v-dialog>
                <v-dialog v-else v-model="dialogImage" :max-width="isMobile ? '90%' : '50%'">
                  <div class="preloader" v-if="videoLoader">
                    <v-progress-circular
                      :size="75"
                      :width="7"
                      color="primary"
                      :indeterminate="videoLoader"
                      class="preloader-circular"
                    >
                    </v-progress-circular>
                  </div>
                  <video
                    class="dialog-video"
                    ref="streamEl"
                    alt="Видео отсутствует"
                    autoplay
                  ></video>
                </v-dialog>
              </div>
              <div v-if="doorphone.physical_status === 6">
                <v-img
                  max-width="550"
                  max-height="400"
                  class="image-device mt-2"
                  :src="require('../../../../../public/intercom-awaiting-installation.jpg')"
                  @click="zoomPhoto(require('../../../../../public/intercom-awaiting-installation.jpg'))">
                </v-img>
              </div>
              <div v-if="doorphone.physical_status === 5">
               <v-img
                 max-width="550"
                 max-height="400"
                 class="image-device mt-2"
                 :src="require('../../../../../public/intercom-old-intercom.jpg')"
                 @click="zoomPhoto(require('../../../../../public/intercom-old-intercom.jpg'))">
               </v-img>
              </div>
              <v-dialog v-model="showZoomPhoto" :max-width="isMobile ? '90%' : '50%'" @input="closeZoomPhoto">
                <zoom-photo
                  v-model="showZoomPhoto"
                  :photo="currentZoomPhoto"
                  @closeZoomPhoto="closeZoomPhoto()"
                >
                </zoom-photo>
              </v-dialog>
            </v-col>
            <v-col class="detailed-info-device__box-2">
                <detailed-info
                :doorphone="doorphone"
                :is-check-size-small="isCheckSizeSmall"
                />
            </v-col>
            <v-col cols="12" sm="12" class="detailed-info-device__box-3">
              <v-card class="border card-info-clue">
                <v-carousel
                  :cycle="roleName !== 'admin'"
                  interval="8000"
                  show-arrows-on-hover
                  height="400"
                  hide-delimiter-background
                >
                  <v-carousel-item>
                    <v-sheet color="#4C6C93" height="100%">
                      <div class="pa-6">
                        <h1 class="info-warning">
                          <div>
                            <div v-for="(item, index) in statisticsIntercoms" :key="index">
                              <StatisticLabelInfo
                                :label="item.label"
                                :value="item.value"
                                :check="item.check"
                                :icon="item.icon"
                                :br-check="item.brCheck"
                                :is-check-size-small="isCheckSizeSmall"
                                :to="item.to"
                                :is-router-link="item.isRouterLink"
                              />
                            </div>
                            <div v-if="doorphone.physical_status === 6">
                              <h4 class="h4-statistics-device mt-4">Домофон без устройства</h4>
                            </div>
                            <div v-else-if="doorphone.physical_status === 5">
                              <h4 class="h4-statistics-device mt-4">Домофон старого образца</h4>
                              <p>Устройство: {{ doorphone.old_device_name }}</p>
                            </div>
                            <div v-else>
                              <h4 class="h4-statistics-device">Устройство</h4>
                              <p>ip-адрес: {{ doorphone.device.ip_address }}</p>
                              <p>Производитель: {{ doorphone.device.manufacturer }}</p>
                              <p>Модель: {{ doorphone.device.model }}</p>
                            </div>
                          </div>
                        </h1>
                      </div>
                      <div style="position: absolute; bottom: 15px; right: 15px;">
                        <v-icon style="font-size: 50px; height: inherit;" color="#87A1B9">mdi-information-outline</v-icon>
                      </div>
                    </v-sheet>
                  </v-carousel-item>
                  <v-carousel-item v-for="(slide, i) in slides" :key="i">
                    <v-sheet :color="slide.color" height="100%">
                      <div class="pa-6">
                        <h1 class="info-warning">
                          <div v-html="slide.title" />
                        </h1>
                      </div>
                      <div style="position: absolute; bottom: 15px; right: 15px;">
                        <v-icon style="font-size: 50px; height: inherit;" :color="slide.colorIcon">{{ slide.icon }}</v-icon>
                      </div>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
              </v-card>
            </v-col>
          </div>
        </div>
        <div class="detailed-info__block-2">
          <v-row no-gutters>
            <v-col cols="12" sm="11" class="mt-4" style="cursor: pointer;">
              <div
                v-for="page in pageStore"
                :key="page.title"
                class="hover-scale-effect"
              >
                <v-card
                  class="border card-info-btn"
                  :color="page.colorCard"
                  :class="{'disabled' : page.isDisabled }"
                  v-if="page.show"
                  @click="handleClick(page)"
                >
                  <div style="display: flex; height: 100%">
                    <v-card style="border-radius: 16px; width: 35%; height: 100%; text-align: center;" :color="page.colorCardIcon">
                      <v-icon style="font-size: 40px; height: inherit;" color="white">{{ getIcon(page) }}</v-icon>
                    </v-card>
                    <div class="btn-page-store" v-html="page.title" />
                  </div>
                </v-card>
              </div>
            </v-col>
            <v-dialog v-model="dialogBuyKey" max-width="900" content-class="dialog-border-radius">
              <BaseSaleItemDoorphoneModal
                :active.sync="dialogBuyKey"
                @close="dialogBuyKey = false"
                @complete="getNewKeyIntercom"
                :att-popup-doorphone-content="doorphone"
                :basic-info-devices="basicInfoIntercoms"
                type-services="buyKey"
                price-key="250"
                header="Реализация ключа доступа"
                icon="mdi-key-variant"
                :is-cellar="true"
              />
            </v-dialog>
            <v-dialog v-model="dialogBuyPhone" max-width="800" content-class="dialog-border-radius">
              <BaseSaleItemDoorphoneModal
                :active.sync="dialogBuyPhone"
                @close="dialogBuyPhone = false"
                :att-popup-doorphone-content="doorphone"
                :basic-info-devices="basicInfoIntercoms"
                type-services="buyPhone"
                :connection-cost="2000"
                :intercom-cost="doorphone.phone_setup_cost"
                header="Заказать установку переговорного устройства"
                icon="mdi-phone-in-talk"
                :is-cellar="true"
              />
            </v-dialog>
            <v-dialog v-model="dialogBuyBarrier" max-width="800" content-class="dialog-border-radius">
              <BaseSaleItemDoorphoneModal
                :active.sync="dialogBuyBarrier"
                @close="dialogBuyBarrier = false"
                :att-popup-doorphone-content="doorphone"
                :basic-info-devices="basicInfoIntercoms"
                type-services="buyKeyBarrier"
                price-key="250"
                header=" Продажа брелока от шлагбаума (ворот) "
                icon="mdi-car-connected"
                :is-cellar="true"
              />
            </v-dialog>
            <v-dialog v-model="dialogCallPhone" max-width="800" content-class="dialog-border-radius">
              <call-doorphone-dialog
                :active.sync="dialogCallPhone"
                @close="dialogCallPhone = false"
                :id="doorphone.id"
                :model="doorphone.device.model"
                :item="doorphone"
                :basic-info-devices="basicInfoIntercoms"
                icon="mdi-phone-incoming"
                message="Тестовый вызов в квартиру"
              />
            </v-dialog>
            <v-dialog v-model="getCodeDoorDialog" max-width="800" content-class="dialog-border-radius">
              <door-opening-code-dialog
                @close="getCodeDoorDialog = false"
                :id="doorphone.id"
                :model="doorphone.device.model"
                :item="doorphone"
                :basic-info-devices="basicInfoIntercoms"
                icon="mdi-lock-clock"
                message="Временный код открытия двери"
              />
            </v-dialog>
          </v-row>
        </div>
      </div>
      <v-row no-gutters class="pb-4 mt-2">
        <v-col cols="12" sm="12" md="7" lg="7">
          <v-card v-if="isNoOneTiedAdditional" class="border info-additional">
            <div class="pa-4 tied">
              <p v-if="doorphone.additionalEntrances[0]">
                Дополнительный вход:
                <template v-for="(doorphones, index) of displayedEntrances">
                  <router-link class="routerLink ml-3" :key="doorphones.id" :to="`/doorphones/${doorphones.id}`">
                    Домофон №{{ doorphones.id }}
                  </router-link>
                  <template v-if="index !== doorphone.additionalEntrances.length - 1">,</template>
                </template>
                .
                <span v-show="doorphone.additionalEntrances.length > 4" class="ml-2">
                  <button @click="toggleEntrances">
                    <v-icon>{{ showAllEntrances ? 'mdi-chevron-triple-left' : 'mdi-chevron-triple-right' }}</v-icon>
                  </button>
                </span>
              </p>
              <p v-if="doorphone.gates[0] || doorphone.doorphone_gates[0]">
                Калитка:
                <template v-for="(doorphoneGate, index) of [...doorphone.gates, ...doorphone.doorphone_gates]">
                  <router-link class="routerLink" :key="doorphoneGate.id"
                               :to="doorphone.gates.includes(doorphoneGate) ? `/gate/${doorphoneGate.id}` : `/doorphones/${doorphoneGate.id}`">
                    Домофон №{{ doorphoneGate.id }}
                  </router-link>
                  <template v-if="index !== doorphone.gates.length + doorphone.doorphone_gates.length - 1">,</template>
                </template>
                .
              </p>
              <p v-if="doorphone.mainDoorphones[0]">
                Основной вход:
                <template v-for="(doorphones, index) of displayedMainDoorphones">
                  <router-link class="routerLink ml-3" :key="doorphones.id" :to="`/doorphones/${doorphones.id}`">
                    Домофон №{{ doorphones.id }}
                  </router-link>
                  <template v-if="index !== doorphone.mainDoorphones.length - 1">,</template>
                </template>
                <span v-show="doorphone.mainDoorphones.length > 4" class="ml-2">
                  <button @click="toggleMainDoorphones">
                    <v-icon>{{ showAllMainDoorphones ? 'mdi-chevron-triple-left' : 'mdi-chevron-triple-right' }}</v-icon>
                  </button>
                </span>
                .
              </p>
              <p v-if="doorphone.barriers[0]">
                Шлагбаум / ворота:
                <template v-for="(tmp, index) of displayedBarriers">
                  <router-link class="routerLink ml-3" :key="tmp.id" :to="`/barrier/${tmp.id}`">
                    {{ displayTiedBarriers }}{{tmp.id}}
                  </router-link>
                  <template v-if="index !== doorphone.barriers.length - 1">,</template>
                </template>
                <span v-show="doorphone.barriers.length > 4" class="ml-2">
                  <button @click="toggleBarriers">
                    <v-icon>{{ showAllBarriers ? 'mdi-chevron-triple-left' : 'mdi-chevron-triple-right' }}</v-icon>
                  </button>
                </span>
                .
              </p>
            </div>
          </v-card>
        </v-col>
        <v-col class="col-btn-additional">
          <div
            v-for="page in additionalButtons"
            :key="page.title"
            style="display: flex"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="page.show"
                  :color="page.colorCard"
                  class="border card-footer-button hover-scale-effect"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="page.isDisabled"
                  @click="page.click"
                  style=""
                >
                  <v-icon style="font-size: 40px; height: inherit;" color="white">{{ getIcon(page) }}</v-icon>
                </v-btn>
              </template>
              <span>{{ page.title }}</span>
            </v-tooltip>
          </div>
        </v-col>
        <v-dialog v-model="detailDialog" max-width="800" content-class="dialog-border-radius">
          <DetailDeviceModal
            :active.sync="detailDialog"
            @close="detailDialog = false"
            :device="doorphone.device"
            :admin-codes="adminCodes"
            :doorphone-id="doorphone.id"
          />
        </v-dialog>
      </v-row>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import VueApexCharts from 'vue-apexcharts';
import callDoorphoneDialog from '../../callDoorphoneDialog.vue';
import doorOpeningCodeDialog from '../../doorOpeningCodeDialog.vue';
import DetailDeviceModal from '../../../device/DetailDeviceModal.vue';
import Hls from 'hls.js';
import { headersDevice, headersSip } from '@/components/doorphone/DetailDoorphone/consts';
import BaseSaleItemDoorphoneModal from '@/components/baseModal/BaseSaleItemDoorphoneModal.vue';
import DetailedInfo from '@/components/doorphone/DetailDoorphone/components/GeneralInfo/components/DetailedInfo.vue';
import StatisticLabelInfo from '@/components/StatisticLabelInfo.vue';
import zoomPhoto from '@/components/client/DetailClient/components/zoomPhoto.vue';

export default {
  components: {
    DetailedInfo,
    // apexchart: VueApexCharts,
    BaseSaleItemDoorphoneModal,
    StatisticLabelInfo,
    DetailDeviceModal,
    callDoorphoneDialog,
    doorOpeningCodeDialog,
    zoomPhoto,
  },
  name: 'GeneralInfo',
  props: ['id'],
  data () {
    return {
      chartOptions: {
        chart: {
          type: 'pie',
        },
        labels: ['Кв в подъезде', 'Всего абонентов'],
        legend: {
          labels: {
            colors: ['#ffffff', '#ffffff'],
          },
        },
        colors: ['#fa6674', '#85B285'],
      },
      baseUrl: '',
      headersDevice,
      headersSip,
      adminCodes: {},
      detailDialog: false,
      getCallDoorphoneDialog: false,
      getCodeDoorDialog: false,
      showAdditionalButtonsMenu: false,
      loading: false,
      heating: {},
      showZoomPhoto: false,
      currentZoomPhoto: '',
      channel: {
        id: this.$route.params.id,
        address: '',
        streamUrl: '',
        link: '',
      },
      dwdr: {},
      dialogImage: false,
      disableRoleName: false,
      streamUrl: '',
      snapshot: '',
      hls: null,
      videoLoader: true,
      dialogBlockAbonent: {},
      dialogUnlockAbonent: {},
      dialogHistory: false,
      isUpdatedSip: false,
      isErrorStreamUrl: false,
      disableRole: false,
      isFirstTimeDialogImageOpened: false,
      isMobile: false,
      filterAbonents: {},
      includeAbonents: ['keys'],
      disableUpdateSnapshot: false,
      isCheckSizeSmall: false,
      dialogImagePlayer: false,
      rotation: 0,
      activeButton: null,
      resComplexName: [],
      dialogBuyKey: false,
      dialogBuyPhone: false,
      dialogBuyBarrier: false,
      dialogCallPhone: false,
      showAllEntrances: false,
      showAllGates: false,
      showAllMainDoorphones: false,
      showAllBarriers: false,
      numberApartments: '',
      allAbonents: '',
    };
  },
  created () {
    this.loadDoorphoneData(this.$route.params.id);
    switch (this.roleName) {
      case 'admin': case 'admin-engineer' : this.disableRole = true;
        break;
    }
    if (this.roleName !== 'master') {
      this.getResidentialComplex()
        .then((data) => {
          this.resComplexName = data.data;
        })
        .catch((error) => {
          console.error('Ошибка при получении данных:', error);
        });
    }
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },

  watch: {
    dialogImage: function (val) {
      if (!val) {
        if (this.disableRole && this.$refs.Player?.destroy) {
          this.$refs.Player.destroy();
        }
        if (this.hls) {
          this.hls.stopLoad();
          this.hls.detachMedia();
          this.hls.destroy();
          this.hls = null;
        }
        this.dialogImagePlayer = false;

        return;
      }
      setTimeout(() => {
        this.dialogImagePlayer = this.dialogImage;
      }, 200);
      this.$nextTick(() => {
        if (val && Hls.isSupported()) {
          if (this.streamUrl.url) {
            const hls = new Hls();
            hls.loadSource(this.streamUrl.url);
            hls.attachMedia(this.$refs.streamEl);
            hls.once(Hls.Events.BUFFER_APPENDING, () => {
              this.videoLoader = false;
            });
            hls.once(Hls.Events.ERROR, () => {
              this.dialogImage = false;
              this.videoLoader = false;
              this.$flash_warning('Произошла ошибка во время воспроизведения или загрузки видео');
              hls.stopLoad();
              hls.detachMedia();
            });
            this.hls = hls;
          } else {
            this.dialogImage = false;
            this.$flash_warning(this.streamUrl.error);
            if (this.hls) {
              if (this.disableRole) {
                this.$refs.Player.beforeUnmount();
                this.isFirstTimeDialogImageOpened = true;
              }
              this.hls.stopLoad();
              this.hls.detachMedia();
              this.hls.destroy();
            }
          }
        } else {
          if (this.hls) {
            if (this.disableRole) {
              this.isFirstTimeDialogImageOpened = true;
            }
            this.hls.stopLoad();
            this.hls.detachMedia();
            this.hls.destroy();
            this.videoLoader = true;
          }
        }
      });
    },
    '$route.params.id' (newId, oldId) {
      if (newId && newId !== oldId) {
        this.getDoorphone({ id: newId })
          .then(() => {
            this.loadDoorphoneData(newId);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404) {
              this.$flash_danger('Домофон не найден или был удалён');
            } else {
              this.$flash_warning('Ошибка при загрузке информации о домофоне');
            }
          });
      }
    },
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
      sipHistory: 'Doorphone/sipHistory',
      roleName: 'roleName',
    }),
    isNoOneTiedAdditional () {
      return this.doorphone.additionalEntrances[0] || this.doorphone.gates[0] || this.doorphone.mainDoorphones[0] ||
        this.doorphone.barriers[0] || this.doorphone.doorphone_gates[0];
    },
    displayedEntrances () {
      return this.showAllEntrances ? this.doorphone.additionalEntrances : this.doorphone.additionalEntrances.slice(0, 4);
    },
    displayedGates () {
      const combinedGates = [...this.doorphone.gates, ...this.doorphone.doorphone_gates];
      return this.showAllGates ? combinedGates : combinedGates.slice(0, 4);
    },
    displayedMainDoorphones () {
      return this.showAllMainDoorphones ? this.doorphone.mainDoorphones : this.doorphone.mainDoorphones.slice(0, 4);
    },
    displayedBarriers () {
      return this.showAllBarriers ? this.doorphone.barriers : this.doorphone.barriers.slice(0, 4);
    },
    slides () {
      const slidesArray = [
        {
          title:
            'А вы знали, что количество бесплатных ключей зависит от принятого жильцами дома коммерческого предложения.<br><br>' +
            'В основном предлагается два варианта - 1 или 2 ключа.',
          color: '#85B285',
          colorIcon: '#87A1B9',
          icon: 'mdi-information-outline',
        },
        {
          title: 'А вы знали, что не на каждом доме возможна установка трубки в квартиру?<br><br>Обратите внимание на данное поле. ' +
            'Есть дома где нет технической возможности прокладки кабеля по подъезду.',
          color: '#E0B389',
          colorIcon: '#87A1B9',
          icon: 'mdi-information-outline',
        },
        {
          title: 'Важно обращать внимание на агента.<br><br>Агент - это компания осуществляющая обслуживание ' +
            'оборудования и монтаж переговорного устройства <br><br>Заявки на ремонт и установку необходимо передавать им.',
          color: '#1f3965',
          colorIcon: '#87A1B9',
          icon: 'mdi-information-outline',
        },
        {
          title: 'Если на адресе имеются калитки <br>То ключи в них добавлять не нужно <br><br>Они автоматически ' +
            'добавляются при добавлении ключа на адрес абонента',
          color: '#fd7b7b',
          colorIcon: '#87A1B9',
          icon: 'mdi-information-outline',
        },
      ];
      return slidesArray;
    },
    pageStore () {
      const doorphoneLinks = {
        Y: 'https://b24-d5ej1n.bitrix24.site/crm_form_kw612',
        IC: 'https://b24-d5ej1n.bitrix24.site/crm_form_voovo',
        N: 'https://b24-d5ej1n.bitrix24.site/crm_form_voovo',
      };

      const phoneSetup = this.doorphone?.possibility_phone_setup?.trim();
      const isPhoneSetupSet = phoneSetup && phoneSetup in doorphoneLinks;

      return [
        {
          title: 'Создание домофонного ключа',
          color: '#1E6CEB',
          icon: 'mdi-key-variant',
          colorCard: 'rgba(172, 204, 172, 0.5)',
          colorCardIcon: '#85B285',
          show: true,
          click: this.openDialogBuyKey,
          isDisabled: this.doorphone.physical_status === 5 || !this.$checkPermission('create_key'), // старый домофон
        },
        {
          title: isPhoneSetupSet
            ? 'Переговорное устройство'
            : 'Перед продажей трубки <br>Укажите возможность "Установка трубки" в настройках',
          color: '#1E6CEB',
          icon: 'mdi-phone-in-talk',
          colorCard: 'rgba(172, 204, 172, 0.5)',
          colorCardIcon: '#85B285',
          isDisabled: !isPhoneSetupSet,
          show: true,
          url: isPhoneSetupSet ? doorphoneLinks[phoneSetup] : null,
        },
        {
          title: 'Предоставить временный код',
          color: '#1E6CEB',
          icon: 'mdi-lock-clock',
          colorCard: 'rgba(224, 179, 137, 0.5)',
          colorCardIcon: '#E0B389',
          show: true,
          click: this.getCodeDialog,
          isDisabled: this.isDoorphoneDisabled || this.roleName === 'master',
        },
        {
          title: 'Тестовый вызов в квартиру',
          color: '#1E6CEB',
          icon: 'mdi-phone-incoming',
          colorCard: 'rgba(224, 179, 137, 0.5)',
          colorCardIcon: '#E0B389',
          show: true,
          click: this.getDialogCallPhone,
          isDisabled: this.isDoorphoneDisabled,
        },
      ];
    },
    additionalButtons () {
      return [
        {
          title: 'Редактировать',
          color: '#1E6CEB',
          icon: 'mdi-pencil',
          colorCard: '#1E6CEB',
          show: this.$canRoute('EditDoorphone') && !this.deviceCheck,
          click: this.editDoorphone,
        },
        {
          title: 'Открыть дверь',
          color: 'success',
          icon: 'mdi-location-exit',
          colorCard: '#85B285',
          show: this.$checkPermission('open_door_doorphone'),
          click: this.openDoorClick,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          title: 'Обновить изображение',
          color: '#1E6CEB',
          icon: 'mdi-reload',
          colorCard: '#4C6C93',
          click: this.updateSnapshotClick,
          show: this.$checkPermission('update_snapshot_doorphone'),
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          title: 'Информация о устройстве',
          color: '#1E6CEB',
          icon: 'mdi-information-outline',
          colorCard: '#4C6C93',
          click: this.openDetailDialogDevice,
          show: true,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          title: 'Переход на web морду',
          color: '#1E6CEB',
          icon: 'mdi-monitor-eye',
          colorCard: '#4C6C93',
          click: this.transitionWebDevice,
          show: true,
          isDisabled: this.isDoorphoneDisabled,
        },
        {
          title: 'Перезагрузка',
          color: 'error',
          icon: 'mdi-cog-sync-outline',
          colorCard: '#B81B1B',
          show: this.$checkPermission('reboot_doorphone'),
          click: this.reboot,
          isDisabled: this.isDoorphoneDisabled,
        },
      ];
    },
    contractType () {
      if (this.doorphone.contract_type === 'I') {
        return 'Индивидуальный договор';
      }
      if (this.doorphone.contract_type === 'M') {
        return 'Договор с УК';
      }
      return '';
    },
    deviceCheck () {
      return this.roleName === 'manager' && this.doorphone.device.manufacturer === 'Akuvox';
    },
    displayDWDRLevel () {
      if (this.dwdr.dwdr_level === 1) {
        return 'Низкий';
      }
      if (this.dwdr.dwdr_level === 2) {
        return 'Средний';
      }
      return 'Высокий';
    },
    displayTiedBarriers (item) {
      if (item.passage_type === 'G') {
        return 'Ворота № ';
      }
      return 'Шлагбаум № ';
    },
    control (item) {
      return item.doorphone.device.manufacturer === 'Rubetek';
    },
    controlBeward (item) {
      return item.doorphone.device.manufacturer !== 'Beward';
    },
    getDiapason () {
      return `${this.doorphone.diapason_from} - ${this.doorphone.diapason_to}`;
    },
    displayCode () {
      if (this.control) {
        return this.adminCodes.doors;
      } else {
        return '';
      }
    },
    groupManagement () {
      if (this.doorphone.management_company) {
        if (this.doorphone.management_company.management_group) {
          return this.doorphone.management_company.management_group.name;
        }
      } else {
        return false;
      }
      return '';
    },
    getAllUniversalKeysDoorphone () {
      const universalKeys = this.doorphone.keys.filter(key => key.universal === 1);
      return universalKeys.length;
    },
    basicInfoIntercoms () {
      return [
        { label: 'Домофон', value: this.doorphone.id, check: '1' },
        { label: 'Город', value: this.doorphone.address.split(' ')[0], check: this.doorphone.address },
        { label: 'Район', value: this.doorphone.region_name, check: this.doorphone.region_name },
        { label: 'Адрес', value: this.doorphone.address, check: this.doorphone.address },
        { label: 'Подъезд', value: this.doorphone.entrance, check: this.doorphone.entrance },
        { label: 'Диапазон', value: this.getDiapason, check: this.doorphone.diapason_from },
      ];
    },
    statisticsIntercoms () {
      return [
        {
          label: 'Жилой комплекс',
          value: this.getResidentialComplexName(this.doorphone.residential_complex_id),
          check: this.getResidentialComplexName(this.doorphone.residential_complex_id),
          isRouterLink: true,
          to: `/residential-complexes/${this.doorphone.residential_complex_id}/view`,
        },
        { label: 'Всего ключей', value: this.doorphone.keys.length, check: '1' },
        { label: 'Универсальных ключей', value: this.getAllUniversalKeysDoorphone, check: '1', brCheck: true },
        {
          label: 'Квартир в подъезде',
          value: this.doorphone.diapason_file && this.doorphone.diapason_file !== 0
            ? this.doorphone.diapason_file
            : (this.doorphone.diapason_to - this.doorphone.diapason_from) + 1,
          check: '1',
        },
        { label: 'Квартир с приложением', value: this.doorphone.apartments_with_app ?? 0, check: '1' },
        { label: 'Квартир PRO-версии', value: this.doorphone.apartments_pro ?? 0, check: '1' },
        { label: 'Всего абонентов', value: this.allAbonents, check: '1' },
      ];
    },
    isDoorphoneDisabled () {
      // ожидает монтажа и старый домофон
      return this.doorphone.physical_status === 6 || this.doorphone.physical_status === 5;
    },
  },
  mounted () {
    if (window.innerWidth < 700) {
      this.isMobile = true;
    }
    this.snapshot = this.doorphone.snapshot;
    this.baseUrl = process.env.VUE_APP_API_URL;
    switch (this.roleName) {
      case 'admin': case 'admin-engineer' : this.disableRoleName = true;
        break;
    }
    switch (this.roleName) {
      case 'manager': this.disableUpdateSnapshot = true;
        break;
    }
  },
  methods: {
    ...mapActions({
      getDoorphone: 'Doorphone/getDoorphone',
      getSipHistory: 'Doorphone/getSipHistory',
      heatingView: 'Doorphone/heatingView',
      loadAbonents: 'Abonents/loadAbonents',
      dwdrView: 'Doorphone/dwdrView',
      getDoorphoneVideo: 'Doorphone/getDoorphoneVideo',
      openDoor: 'Doorphone/openDoor',
      loadAdminCodes: 'MainSetups/getAdminCodes',
      importSipStatus: 'Doorphone/getSipStatus',
      rebootDoorphone: 'Doorphone/rebootDoorphone',
      exportSipHistoryCsv: 'Doorphone/exportSipHistoryCsv',
      updateSnapshot: 'Doorphone/updateSnapshot',
      newKey: 'Keys/newDoorphoneKey',
      getResidentialComplex: 'ResidentComplex/getComplex',
    }),
    zoomPhoto (photo) {
      this.currentZoomPhoto = photo;
      this.showZoomPhoto = true;
    },
    closeZoomPhoto () {
      this.showZoomPhoto = false;
      this.currentZoomPhoto = null;
    },
    handleClick (page) {
      if (!page.isDisabled && page.url) {
        window.open(page.url, '_blank');
      }
      if (page.click) {
        page.click();
      }
    },
    getResidentialComplexName (id) {
      const complex = this.resComplexName.find(item => item.id === id);
      return complex ? complex.name : '';
    },
    toggleEntrances () {
      this.showAllEntrances = !this.showAllEntrances;
    },
    toggleMainDoorphones () {
      this.showAllMainDoorphones = !this.showAllMainDoorphones;
    },
    toggleBarriers () {
      this.showAllBarriers = !this.showAllBarriers;
    },
    openDetailDialogDevice () {
      this.detailDialog = true;
    },
    getIcon (page) {
      return this.activeButton === page.title ? page.iconHover : page.icon;
    },
    openDialogBuyKey () {
      this.dialogBuyKey = true;
    },
    openDialogBuyPhone () {
      this.dialogBuyPhone = true;
    },
    openDialogBuyBarrier () {
      this.dialogBuyBarrier = true;
    },
    getDialogCallPhone () {
      this.dialogCallPhone = true;
    },
    getCodeDialog () {
      this.getCodeDoorDialog = true;
    },
    getAbonents () {
      this.filterAbonents.doorphone_id = this.$route.params.id;
      this.loadAbonents({
        filters: this.filterAbonents,
      })
        .then((data) => {
          this.allAbonents = data.abonents.length;
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при загрузке абонентов');
          }
        });
    },
    transitionWebDevice () {
      let hrefDevice;
      if (this.doorphone.device.model === 'RV-3434') {
        hrefDevice = `http://${this.doorphone.device.ip_address}.intercom.access.simdev.ru:8000/`;
      } else {
        hrefDevice = `http://${this.doorphone.device.ip_address}.intercom.access.simdev.ru/`;
      }
      window.open(hrefDevice, '_blank');
    },
    getDialogImage () {
      if (!this.isErrorStreamUrl) {
        if (this.disableRole) {
          if (this.isFirstTimeDialogImageOpened) {
            if (this.$refs.Player) {
              this.$refs.Player.getPlayer();
            }
          } else {
            this.isFirstTimeDialogImageOpened = false;
          }
        }
        this.dialogImage = true;
      } else {
        this.$flash_danger('Ошибка видео, обновите страницу.');
      }
    },
    checkSize () {
      this.isCheckSizeSmall = window.innerWidth <= 600;
    },
    getNewKeyIntercom (numberApartment, codeKey, selectedType, keyDuplicate, fullName, internalReader, externalReader) {
      const tempKey = {
        code: codeKey,
        universal: selectedType,
        duplicate: +keyDuplicate,
        name: numberApartment,
      };

      if (fullName) {
        tempKey.comment = fullName;
      }

      const internalReaders = internalReader.sort().join('');
      const externalReaders = externalReader.sort().join('');
      tempKey.doornum = (internalReaders === '') ? 0 : parseInt(internalReaders);
      tempKey.ext_reader_doornum = (externalReaders === '') ? 0 : parseInt(externalReaders);

      this.newKey({
        doorphoneId: this.$route.params.id,
        key: tempKey,
      })
        .then(() => {
          this.$flash_success('Ключ успешно создан');
        })
        .catch((message) => {
          if (message.length > 0) {
            for (let i = 0; i < message.length; i++) {
              this.$flash_warning(message[i]);
            }
          } else {
            this.$flash_warning('Ошибка при создании ключа');
          }
        });
      this.dialogBuyKey = false;
    },
    editDoorphone () {
      const value = this.doorphone.id;
      let { id } = value;
      if (!id) {
        id = value;
      }
      this.$router.push({ name: 'EditDoorphone', params: { id: id } });
    },
    reboot () {
      this.rebootDoorphone(this.doorphone.id)
        .then(() => {
          this.$flash_success('Домофон перезагружается');
        })
        .catch(() => {
          this.$flash_warning('Не удалось перезагрузить домофон');
        });
    },
    updateSnapshotClick (value) {
      this.loading = true;
      this.updateSnapshot({ id: this.doorphone.id })
        .then((response) => {
          this.snapshot = response.snapshot;
          if (!value) {
            this.$flash_success('Изображение обновилось');
          }
        })
        .catch(() => {
          this.$flash_warning('Ошибка обновления изображения домофона');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDoorClick () {
      this.openDoor(this.doorphone.id)
        .then(() => {
          this.$flash_success('Дверь открыта');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при открытии двери');
        });
    },
    loadDoorphoneData (doorphoneId) {
      if (this.doorphone.physical_status !== 5) {
        if (this.roleName !== 'master') {
          this.getAbonents();
        }
        this.getDoorphoneVideo(doorphoneId).then(stream => {
          this.streamUrl = {
            url: stream,
          };
          this.channel.id = doorphoneId;
          this.channel.link = `${process.env.VUE_APP_API_URL}/doorphone/${doorphoneId}/camera-archive`;
          this.channel.streamUrl = this.streamUrl.url;
        }).catch((err) => {
          this.isErrorStreamUrl = true;
          this.streamUrl = {
            error: (err.response && err.response.data && err.response.data.error) || 'Ошибка загрузки видео',
          };
        });
        if (this.disableUpdateSnapshot) {
          this.updateSnapshotClick(true);
        }
        if (this.$checkPermission('view_sip_status_logs')) {
          this.getSipHistory(doorphoneId);
        }
        if (this.roleName !== 'call-center') {
          this.loadAdminCodes(doorphoneId).then(res => {
            this.adminCodes = res;
          });
        }
        if (this.roleName !== 'call-center' && this.doorphone.physical_status !== 6) {
          if (this.controlBeward) {
            if (this.doorphone.device.model === 'RV-3438') {
              this.heatingView(doorphoneId).then(res => {
                this.heating = res;
              });
            }
          } else {
            this.dwdrView(doorphoneId)
              .then(res => {
                this.dwdr = res;
              })
              .catch(() => {
                this.$flash_warning('Не удалось получить настройки изображения');
              });
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  border-radius: 16px;
}
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: cornflowerblue;
}

a:hover.routerLink {
  text-decoration: underline;
}

.information p {
  margin-bottom: 4px;
}

.v-application p {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 17px;
  font-family: 'Montserrat', sans-serif;
}
.intercom-info {
  font-weight: 400 !important;
  padding-left: 15px;
  font-size: 16px;
}
@media screen and (max-width: 1500px) {
  .v-application p {
    font-size: 16px
  }
  .apex-chart {
    height: auto;
  }
}
</style>
